import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {VetClinic, VImage} from "../../models/vet-clinic.model";
import {Subscription} from "rxjs";
import {VetClinicInfoData} from "../../models/vet-clinic-info-data.model";
import {User} from "../../models/user.model";
import {VetVisitType, VisitType} from "../../models/vet-clinic-data.model";
import {AppStateService} from "../../providers/app-state.service";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {CommonUtils} from "../../utils/common";
import {FileService} from "../../providers/file.service";
import {ModalController} from "@ionic/angular";
import {Router} from "@angular/router";

@Component({
  selector: 'app-clinic-timetable-edit',
  templateUrl: './clinic-timetable-edit.component.html',
  styleUrls: ['./clinic-timetable-edit.component.scss'],
})
export class ClinicTimetableEditComponent implements OnInit {

  @Input()
  vetClinic: VetClinic;

  @Output()
  vetClinicEditedEmitter: EventEmitter<VetClinic> = new EventEmitter<VetClinic>();
  @Output()
  cancelVetClinicEditedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output()
  hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  isBusySub: Subscription;

  vetClinicInfoData: VetClinicInfoData;

  services: string[];

  vImages: VImage[];

  visitTypesKeys: string[];


  hasUnsavedChanges: boolean = false;

  maxTextAreaLength = 255;
  isAdmin: boolean;
  isGeneralAdmin: boolean;
  loggedUser: User;
  images: VImage[];
  vc: VetClinic;
  selectedGVisitType: any;
  vTypes: VisitType[] = [];
  isBusy: boolean;
  servicesItems: string[];
  fakturowniaTermsAccepted = false;
  dataLoaded: boolean = false;
  private alertPresented: boolean = false;
  private previousTextAreaLength: number;


  constructor(private appStateService: AppStateService, private vetClinicService: VetClinicService, private commonUtils: CommonUtils,
              private fileService: FileService, private modalController: ModalController, private router: Router) {
  }


  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    this.appStateService.updateIsBusySubject(true);
    this.vTypes = this.vetClinic.visitTypes;
    this.selectedGVisitType = 'all-types';

    this.vetClinic.visitTypes.forEach(visitType => {
      let vetVisitType = this.vetClinic?.vetVisitTypes?.filter(e => e.klinikaXpVisitId === visitType.xid)[0];
      if (vetVisitType === undefined) {
        return visitType;
      } else {
        visitType.prepaidPrice = vetVisitType?.prepaidPrice
        visitType.online = vetVisitType?.online
        visitType.prepaidRequired = vetVisitType?.prepaidRequired
        return visitType
      }
    })

    if (this.vetClinic?.services) {
      this.services = JSON.parse(this.vetClinic.services);
      this.servicesItems = JSON.parse(this.vetClinic.services);
    }

    this.vetClinicService.checkIfFakturowniaAccepted(this.vetClinic.uuid).subscribe(cl => {
      if(cl && cl.fakturowniaApproved){
        this.fakturowniaTermsAccepted = true;
      }
      this.dataLoaded =true;
    });

    this.vc = JSON.parse(JSON.stringify(this.vetClinic));
    this.appStateService.updateIsBusySubject(false);

  }

  goTo(page: string) {
    this.router.navigateByUrl(page);
  }

  handleVisitTypeMultimediaEnabledToggle(vetVisitType: VetVisitType, event: any) {
    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === vetVisitType.klinikaXpVisitId) {
        if (event.detail.checked) {
          e.multimediaEnabled = true;
        } else {
          e.multimediaEnabled = false;
        }
      }
      return e;
    });
    this.markUnsavedChanges();
  }

  transformVisitTypeToVetVisitType(visitType: VisitType): VetVisitType {
    let vetVisitType = this.vetClinic?.vetVisitTypes?.filter(e => e.klinikaXpVisitId === visitType.xid)[0];

    if (vetVisitType === undefined) {
      let newVetVisitType = new VetVisitType();
      newVetVisitType.klinikaXpVisitId = visitType.xid
      newVetVisitType.online = visitType.online
      newVetVisitType.info = visitType.info;

      this.vetClinic.vetVisitTypes.push(newVetVisitType)
      return newVetVisitType;
    } else {
      return vetVisitType;
    }
  }

  private handleGroupedVisitTypeSelected(selectedValue) {
    this.selectedGVisitType = selectedValue?.trim();

    if (this.selectedGVisitType === 'all-types') {
      this.vTypes = this.vetClinic.visitTypes;
    } else {
      this.vTypes = this.vetClinic.visitTypes.filter(e => e.name?.trim() === selectedValue)
    }

  }

  getDoctorName(whObjId: number) {
    const doctorName = this.vetClinic.team.find(vd => {
      if (vd.whObjId === whObjId) {
        return vd;
      }
    });

    if (doctorName !== undefined) return doctorName?.name;
    else return "Wszyscy";
  }


  handleVisitTypeOnlineToggle(klinikaxid: number, event: any) {
    this.vetClinic.visitTypes = this.vetClinic.visitTypes.map(e => {
      if (e.xid === klinikaxid) {
        if (event.detail.checked) {
          e.online = true;
          e.prepaidRequired = true;
        } else {
          e.online = false;
          e.prepaidRequired = false
        }
      }
      return e;
    });

    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === klinikaxid) {
        if (event.detail.checked) {
          e.online = true;
          e.prepaidRequired = true;
        } else {
          e.online = false;
          e.prepaidRequired = false

        }
      }
      return e;
    });

    // (event.detail.checked ? this.vetClinic.visitTypes[idx].online = true : this.vetClinic.visitTypes[idx].online = false);
    // (event.detail.checked ? this.vetClinic.vetVisitTypes[idx].online = true : this.vetClinic.vetVisitTypes[idx].online = false);
    // if (this.vetClinic.vetVisitTypes[idx].online) {
    //   this.vetClinic.vetVisitTypes[idx].prepaidRequired = true;
    // }
    // if (this.vetClinic.visitTypes[idx].online) {
    //   this.vetClinic.visitTypes[idx].prepaidRequired = true;
    // }
    this.markUnsavedChanges();
  }

  handleVisitTypePrepaidToggle(klinikaxid: number, event: any) {

    this.vetClinic.visitTypes = this.vetClinic.visitTypes.map(e => {
      if (e.xid === klinikaxid) {
        if (event.detail.checked) {
          e.prepaidRequired = true;
        } else {
          e.prepaidRequired = false;
        }
      }
      return e;
    });

    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === klinikaxid) {
        if (event.detail.checked) {
          e.prepaidRequired = true;
        } else {
          e.prepaidRequired = false;
        }
      }
      return e;
    });

    // (event.detail.checked ? this.vetClinic.visitTypes[idx].prepaidRequired = true : this.vetClinic.visitTypes[idx].prepaidRequired = false);
    // (event.detail.checked ? this.vetClinic.vetVisitTypes[idx].prepaidRequired = true : this.vetClinic.vetVisitTypes[idx].prepaidRequired = false);
    this.markUnsavedChanges();
  }

  handleVisitTypePrepaidPriceChange(klinikaxid: number, event: any) {
    const price = (isNaN(event.detail.value) ? 0 : event.detail.value);
    // this.vetClinic.visitTypes[idx].prepaidPrice = price;
    // this.vetClinic.vetVisitTypes[idx].prepaidPrice = price;

    this.vetClinic.visitTypes = this.vetClinic.visitTypes.map(e => {
      if (e.xid === klinikaxid) {
        if (price) {
          e.prepaidPrice = price;
        }
      }
      return e;
    });

    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === klinikaxid) {
        if (price) {
          e.prepaidPrice = price;
        }
      }
      return e;
    });


    this.markUnsavedChanges();
  }


  buildVetVisitTypeList() {
    return this.vetClinic.visitTypes.filter(visitType => {
      return visitType?.prepaidRequired && visitType?.prepaidPrice > 0;
    }).map((visitType, idx) => {
      const visitTypeObj = this.commonUtils.bestTypedCopyEver<VisitType>(new VisitType(), visitType);
      return visitTypeObj.asVetVisitType();
    });
  }


  onGroupedVisitTypeSelected(event) {
    this.handleGroupedVisitTypeSelected(event?.detail?.value);
  }

  getGroupedVisitTypesKeys() {
    this.visitTypesKeys = [...new Map(this.vetClinic.visitTypes.map(item => [item?.name.trim(), item?.name.trim()])).keys()];
    return this.visitTypesKeys;
  }

  handleVisitTypeComunicationToolsEnabledToggle(vetVisitType: VetVisitType, event: any) {
    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === vetVisitType.klinikaXpVisitId) {
        if (event.detail.checked) {
          e.communicationToolsEnabled = true;
        } else {
          e.communicationToolsEnabled = false;
        }
      }
      return e;
    });
    this.markUnsavedChanges();
  }

  handleInfoChange(klinikaxid: number, event: any) {
    const info = event.detail.value;
    this.previousTextAreaLength = 0;
    this.vetClinic.visitTypes = this.vetClinic.visitTypes.map(e => {
      if (e.xid === klinikaxid) {
        e.info = info;
      }
      return e;
    });

    this.vetClinic.vetVisitTypes = this.vetClinic.vetVisitTypes.map(e => {
      if (e.klinikaXpVisitId === klinikaxid) {
        e.info = info;
      }
      return e;
    });
    this.markUnsavedChanges();
  }

  onCancelEdit() {
    if (this.images && this.images.length > 0) {
      console.log(this.images);
      this.markUnsavedChanges();
    }
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.cancelVetClinicEditedEmitter.emit(true);
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować z edycji kliniki?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.cancelVetClinicEditedEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  private markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
      this.hasUnsavedChanges = true;
    }
  }

  onSave() {
    let visitTypesOk = true;
    console.log(this.vetClinic.vetVisitTypes);
    console.log(this.vetClinic.visitTypes);

    if (this.vetClinic.visitTypes) {
      this.vetClinic.visitTypes.forEach((visitType, idx) => {
        if (visitType.prepaidRequired && (visitType.prepaidPrice === undefined || visitType.prepaidPrice < 10)) {
          this.commonUtils.presentAlertToast(`Wartość vouchera dla wizyty "${visitType.name}" nie może być większy niż 10`);
          visitTypesOk = false;
          return false;
        }
      });

      // this.vetClinic.vetVisitTypes = this.buildVetVisitTypeList();

      if (visitTypesOk) {
        this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
          this.appStateService.updateIsBusySubject(true);

          // this.vetClinic.vetVisitTypes = this.buildVetVisitTypeList();
          console.log(this.vetClinic.vetVisitTypes);
          this.vetClinic.servicesJson = JSON.stringify(this.servicesItems);
          this.vetClinic.vetVisitTypeJsonArray = JSON.stringify(this.vetClinic.vetVisitTypes);
          this.vetClinic.vetVisitTypes =null;

          this.vetClinicService.updateVetClinic(this.vetClinic, false)
            .subscribe((vc: VetClinic) => {
                this.commonUtils.presentInfoToast("Dane lecznicy zostały zmienione").then(res => {
                });
                this.hasUnsavedChanges = false;
                this.vetClinic = null;
                this.vetClinicEditedEmitter.emit(vc);
                this.appStateService.updateIsBusySubject(false);
              },
              error => {
                this.appStateService.updateIsBusySubject(false);
                this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany danych lecznicy");
              });
        }, () => {
        });
      }
    }
  }

  getVetDoctor(doctorId) {
    return this.vetClinic?.team.find(vt => vt.whObjId === doctorId);
  }

  handleTextAreaKeyDown(vetVisitType: VetVisitType, $event: KeyboardEvent) {
    this.previousTextAreaLength = vetVisitType?.info?.length;
  }

  handleTextAreaKeyUp(vetVisitType: VetVisitType, $event: KeyboardEvent) {
    if(vetVisitType?.info?.length === this.maxTextAreaLength && this.previousTextAreaLength === vetVisitType?.info?.length && !this.alertPresented) {
      this.alertPresented = true;
      const alertDuration = 3000;
      this.commonUtils.presentAlertToast('Osiągnięto maksymalną długość informacji.', alertDuration);
      setTimeout(() => {
        this.alertPresented = false;
      }, alertDuration);
    }
  }
}
